/**
 * Default expiration days when creating a payment link (matches API default).
 */
export const PAYMENT_LINK_DEFAULT_EXPIRATION_DAYS = 14;

/**
 * Payment link expiration limit (days). Links cannot exceed this value.
 */
export const PAYMENT_LINK_MAX_EXPIRATION_DAYS = 180;
